import React from 'react';
import PropTypes from 'prop-types';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import numeral from 'numeral';

import { useTheme } from 'contexts/ThemeContext';

import { AssetItem } from 'components/AssetItem';
import { Text, Tooltip } from 'components/DataDisplay';
import { Item } from 'components/Layout';

import { InlineIdEditor } from './InlineIdEditor';

export const CreaRow = ({ crea }) => {
  const { themeColors } = useTheme();
  const { designSystem } = themeColors;
  const { name, asset, mediaUrl, amount, externalId, onSaveId } = crea;

  return (
    <Item
      flex
      style={{
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '9px',
        padding: '7px 6px 7px 40px'
      }}
    >
      <Item
        flex
        style={{
          alignItems: 'center',
          gap: '9px',
          justifyContent: 'flex-start'
        }}
      >
        <Text
          component="span"
          fontSize="12.5px"
          style={{ color: designSystem.inkSoft }}
        >
          {name}
        </Text>
        {(asset || mediaUrl) && (
          <Tooltip title={<AssetItem asset={asset} mediaUrl={mediaUrl} />}>
            <VisibilityOutlinedIcon
              style={{
                fontSize: '15px',
                color: designSystem.faint,
                cursor: 'pointer'
              }}
            />
          </Tooltip>
        )}
        <InlineIdEditor value={externalId} onSave={onSaveId} />
      </Item>
      <Text
        component="span"
        fontSize="12.5px"
        fontWeight={600}
        style={{ color: designSystem.ink, whiteSpace: 'nowrap' }}
      >
        {numeral(amount).format('0,0 $')}
      </Text>
    </Item>
  );
};

CreaRow.propTypes = {
  crea: PropTypes.shape().isRequired
};

export default CreaRow;
